import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { RiBarcodeLine } from 'react-icons/ri';
import { FormInput, Loader, theme, useAuth } from '@omnigenbiodata/ui';
import { useAppDispatch, useAppSelector } from '../../../../../../store';
import { useTranslation } from 'react-i18next';
import {
  Alert,
  Button,
  Chip,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FaUndo } from 'react-icons/fa';
import { useFormik } from 'formik';
import { FaCheck } from 'react-icons/fa';
import { MdWarningAmber } from 'react-icons/md';
import ConfirmationModal from './components/ConfirmationModal';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { DATE_VALUE_FORMAT, DATE_FORMAT } from '../../../../../../core/constants/forms.constants';
import InnerLayout from '../../../../../../layout/Inner';
import ViewSuggestedBoxesModal from './components/ViewSuggestedBoxesModal';
import PickListModal from './components/PickListModal';
import {
  getStagedShipmentMetaIsBusySelector,
  getStagedShipmentMetaResponseSelector,
} from '../../../../../../store/stagedShipmentMetaList/selectors';
import {
  getStagedShipmentThunk,
  stagedShipmentListIsBusySelector,
  stagedShipmentListResponseSelector,
} from '../../../../../../store/stagedShipmentList';
import {
  removeCryoboxFromstagingReset,
  removeCryoboxFromStagingThunk,
} from '../../../../../../store/stagedShipmentCryoboxDelete';
import {
  removeCryoboxFromStagingHasErrorSelector,
  removeCryoboxFromStagingIsBusySelector,
  removeCryoboxFromStagingResponseSelector,
} from '../../../../../../store/stagedShipmentCryoboxDelete/selectors';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { resetStagedShipment } from '../../../../../../store/stagedShipmentReset';
import {
  resetStagedShipmentIsBusySelector,
  resetStagedShipmentResponseSelector,
} from '../../../../../../store/stagedShipmentReset/selectors';
import ROUTES from '../../../../../../core/constants/routes.constants';
import { getStagedShipmentMetaThunk } from '../../../../../../store/stagedShipmentMetaList/thunks';
import {
  getShipmentIsBusySelector,
  getShipmentResponseSelector,
  getShipmentThunk,
} from '../../../../../../store/shipmentGet';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { getShipmentManifestThunk } from '../../../../../../store/shipmentGetManifest/thunks';
import { resetManifestStagedShipment } from '../../../../../../store/stagedShipmentManifest';
import { resetStagedShipmentMeta } from '../../../../../../store/stagedShipmentMetaList';
import { addCryoboxToStagingThunk } from '../../../../../../store/stagedShipmentCryoboxAdd/thunks';
import {
  addCryoboxToStagingHasErrorSelector,
  addCryoboxToStagingIsBusySelector,
  addCryoboxToStagingResponseSelector,
} from '../../../../../../store/stagedShipmentCryoboxAdd/selectors';
import { moveStagedAliquotReset } from '../../../../../../store/stagedShipmentMoveAliquot';
import { isAdmin } from '../../../../../../core/utils/auth';
import { addCryoboxTostagingReset } from '../../../../../../store/stagedShipmentCryoboxAdd';
import StatusMessage from '../../../../../../components/StatusMessage';

function ManageShipmentScene() {
  const { t } = useTranslation('portal');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [showConfirm, setConfirm] = useState(false);
  const stagedMeta = useAppSelector(getStagedShipmentMetaResponseSelector);
  const stagedMetaIsBusy = useAppSelector(getStagedShipmentMetaIsBusySelector);
  const staged = useAppSelector(stagedShipmentListResponseSelector);
  const stagedIsBusy = useAppSelector(stagedShipmentListIsBusySelector);
  const removeBoxIsBusy = useAppSelector(removeCryoboxFromStagingIsBusySelector);
  const removeBoxResponse = useAppSelector(removeCryoboxFromStagingResponseSelector);
  const removeBoxHasError = useAppSelector(removeCryoboxFromStagingHasErrorSelector);
  const resetStagedShipmentResponse = useAppSelector(resetStagedShipmentResponseSelector);
  const resetStagedShipmentIsBusy = useAppSelector(resetStagedShipmentIsBusySelector);
  const shipmentResponse = useAppSelector(getShipmentResponseSelector);
  const shipmentIsBusy = useAppSelector(getShipmentIsBusySelector);
  const addCryoboxToStaging = useAppSelector(addCryoboxToStagingResponseSelector);
  const addCryoboxToStagingBusy = useAppSelector(addCryoboxToStagingIsBusySelector);
  const addCryoboxToStagingErrors = useAppSelector(addCryoboxToStagingHasErrorSelector);

  const { shippingId } = useParams<any>();
  const [showSearchEligibleBoxes, setShowSearchEligibleBoxes] = useState(false);
  const [addedSuccess, setAddedSuccess] = useState<any>({ showMsg: false });
  const [isManualAdd, setIsManualAdd] = useState<boolean>(false);
  const [showPickList, setShowPickList] = useState(false);
  const [ineligibleSamplesCount, setIneligibleSamplesCount] = useState(0);
  const [eligibleSamplesCount, setEligibleSamplesCount] = useState(0);
  const [shipmentStatus, setShipmentStatus] = useState<string>('STAGED');

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      boxBarcode: '',
      shippingDate: moment().format(DATE_VALUE_FORMAT),
    },
    onSubmit: () => {},
  });

  useEffect(() => {
    if (staged && staged.cryoboxes.length > 0) {
      const ineligibleSamplesCount = staged.cryoboxes.reduce((total, box) => total + (box.ineligibleCount || 0), 0);
      const eligibleSampleCount = staged.cryoboxes.reduce((total, box) => total + (box.eligibleCount || 0), 0);

      setIneligibleSamplesCount(ineligibleSamplesCount);
      setEligibleSamplesCount(eligibleSampleCount);
    } else {
      setIneligibleSamplesCount(0);
      setEligibleSamplesCount(0);
    }
  }, [staged]);

  useEffect(() => {
    if (resetStagedShipmentResponse?.stagedShipmentMetaUuid !== undefined) {
      dispatch(resetStagedShipment());
      dispatch(resetStagedShipmentMeta());
      navigate(ROUTES.root);
    }
  }, [dispatch, navigate, resetStagedShipmentResponse]);

  const onViewSuggestedBoxesModalClose = () => {
    setShowSearchEligibleBoxes(false);
    dispatch(getStagedShipmentThunk());
  };

  const onPickListModalClose = () => {
    setShowPickList(false);
    dispatch(moveStagedAliquotReset());
    dispatch(getStagedShipmentThunk());
  };

  useEffect(() => {
    if (removeBoxResponse && removeBoxResponse.cryoboxUuid) {
      dispatch(getStagedShipmentThunk());
    }
  }, [dispatch, removeBoxResponse]);

  useEffect(() => {
    dispatch(getStagedShipmentThunk());

    if (addCryoboxToStaging?.cryoboxUuid) {
      setAddedSuccess({
        showMsg: true,
        boxBarcode: addedSuccess.boxBarcode,
      });

      setTimeout(() => {
        dispatch(addCryoboxTostagingReset());
      }, 5000);
    }
  }, [addCryoboxToStaging, addedSuccess.boxBarcode, dispatch]);

  // useEffect(() => {
  //   if (!addedSuccess.showMsg) return;

  //   const timer = setTimeout(() => {
  //     setAddedSuccess((prev: any) => ({
  //       ...prev,
  //       showMsg: false,
  //     }));
  //   }, 5000);

  //   return () => clearTimeout(timer);
  // }, [addedSuccess.showMsg]);

  useEffect(() => {
    dispatch(getStagedShipmentThunk());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(addCryoboxTostagingReset());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!shippingId) {
      dispatch(getStagedShipmentMetaThunk());
    }
  }, [dispatch, shippingId]);

  const manifestShipment = () => {
    dispatch(resetManifestStagedShipment());
    setConfirm(true);
  };

  useEffect(() => {
    if (shippingId) {
      dispatch(getShipmentThunk(shippingId));
    }
  }, [dispatch, shippingId]);

  useEffect(() => {
    if (stagedMeta && stagedMeta === null) {
      navigate(ROUTES.root);
    }
  }, [navigate, stagedMeta]);

  useEffect(() => {
    if (shipmentResponse?.shipmentId === shippingId) {
      setShipmentStatus(shipmentResponse?.status.toUpperCase() || 'STAGED');
    }
  }, [shipmentResponse, shippingId]);

  const deleteBox = (cryoboxUuid: string) => {
    dispatch(removeCryoboxFromStagingThunk(cryoboxUuid));
  };

  const handleResetStagedShipment = () => {
    navigate(ROUTES.shippingReset);
  };

  const handleDownloadManifest = () => {
    if (shipmentResponse?.shipmentId) {
      dispatch(getShipmentManifestThunk(shipmentResponse?.shipmentId));
    }
  };

  const handleScan = (boxBarcode: any) => {
    setIsManualAdd(true);

    formik.setFieldValue('boxBarcode', boxBarcode);
    setAddedSuccess({
      showMsg: false,
      boxBarcode: boxBarcode,
    });
    dispatch(addCryoboxToStagingThunk({ cryoboxBarcode: boxBarcode, cryoboxUuid: null }));
    formik.setFieldValue('boxBarcode', '');
  };

  const renderShipmentAlert = (hasIssues: number) => {
    const isError = hasIssues;

    return (
      <Alert
        severity={isError ? 'error' : 'success'}
        icon={isError ? <MdWarningAmber size={32} /> : <FaCheck color="#16A34A" size={20} />}
        sx={{
          mb: 2,
          bgcolor: isError ? '#FFF5F5' : '#F5FBF6',
          color: '#2F2F2F',
          border: `1px solid ${isError ? '#F8CACA' : '#D8EEDB'}`,
          borderRadius: 2,
          py: isError ? 2 : 1.5,
          px: 2,
          alignItems: 'flex-start',

          '& .MuiAlert-icon': {
            color: isError ? '#F56C6C' : '#16A34A',
            mt: '3px',
            mr: 2,
            alignSelf: 'flex-start',
            p: 0,
          },

          '& .MuiAlert-message': {
            flex: 1,
            p: 0,
          },
        }}
      >
        <Typography
          sx={{
            color: isError ? '#F56C6C' : '#2E7D32',
            fontWeight: 700,
            mb: 0.5,
          }}
        >
          {isError ? 'Issues to resolve' : 'No issues to resolve'}
        </Typography>

        <Typography variant="body1">
          {isError
            ? 'Some boxes in this staged shipment require remediation before the shipment can be manifested. Review the pick list and confirm the required sample movements.'
            : 'All boxes in this staged shipment have passed the shipment checks. You can continue to review and manifest the shipment.'}
        </Typography>
      </Alert>
    );
  };

  const SHIPMENT_STATUS_COLOUR: any = {
    STAGED: '#1976d2',
    MANIFESTED: '#F56C6C',
    SHIPPED: '#16A34A',
  };

  return (
    <InnerLayout>
      <>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'divider',
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              mb: 2,
            }}
          >
            <Typography variant="h5" fontWeight={600}>
              Shipment Summary
            </Typography>

            {shipmentStatus === 'STAGED' && isAdmin(user) && (
              <Button
                variant="outlined"
                startIcon={<RestartAltIcon />}
                onClick={handleResetStagedShipment}
                sx={{
                  textTransform: 'uppercase',
                  fontWeight: 700,
                  px: 3,
                  py: 1,
                }}
              >
                Reset Shipment
              </Button>
            )}

            {shipmentStatus !== 'STAGED' && (
              <Button
                variant="outlined"
                startIcon={<FileDownloadOutlinedIcon />}
                onClick={handleDownloadManifest}
                sx={{
                  textTransform: 'uppercase',
                  fontWeight: 700,
                  px: 3,
                  py: 1,
                }}
              >
                Download Manifest
              </Button>
            )}
          </Box>

          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <Typography variant="subtitle1" fontWeight={700} color="text.secondary" gutterBottom>
                Shipment Status
              </Typography>

              <Chip
                label={shipmentStatus}
                data-testid="summary-shipment-status"
                sx={{
                  bgcolor: `${SHIPMENT_STATUS_COLOUR[shipmentStatus]}`,
                  color: '#fff',
                  fontWeight: 700,
                  minWidth: 100,
                  height: 30,
                  borderRadius: 20,
                }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="subtitle1" fontWeight={700} color="text.secondary" gutterBottom>
                Shipment Destination
              </Typography>

              <Typography fontWeight={600} data-testid="summary-shipment-destination">
                {stagedMeta?.destinationLocation}
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="subtitle1" fontWeight={700} color="text.secondary" gutterBottom>
                Shipment Type
              </Typography>

              <Typography fontWeight={600} data-testid="summary-shipment-type">
                {stagedMeta?.shipmentType}
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="subtitle1" fontWeight={700} color="text.secondary" gutterBottom>
                Shipment Date
              </Typography>

              <Typography fontWeight={600} data-testid="summary-shipment-date">
                {moment(stagedMeta?.plannedShipmentDate).format(DATE_FORMAT)}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
        {isAdmin(user) && (
          <>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Typography variant="h5" fontWeight={600}>
                Add boxes to your shipment
              </Typography>
              <Typography variant="body1" mb={2}>
                Choose how you want to add cryoboxes to this staged shipment.
              </Typography>

              <StatusMessage
                show={addCryoboxToStagingErrors.hasError}
                severity="error"
                message={addCryoboxToStagingErrors.message}
                onClose={() => dispatch(addCryoboxTostagingReset())}
              />

              <StatusMessage
                show={addedSuccess.showMsg && isManualAdd}
                severity="success"
                message={`Box (${addedSuccess.boxBarcode}) has been added successfully.`}
                onClose={() => {
                  setIsManualAdd(false);
                  dispatch(addCryoboxTostagingReset());
                }}
              />

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={5}>
                  <Typography variant="body1" mb={1} fontWeight={600}>
                    Use suggested boxes
                  </Typography>
                  <Typography variant="body1" mb={2}>
                    Find boxes that are most suitable for shipment based on participant eligibility, sample suitability,
                    and shipment rules.
                  </Typography>
                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    sx={{ height: 50 }}
                    onClick={() => setShowSearchEligibleBoxes(true)}
                  >
                    VIEW SUGGESTED BOXES
                  </Button>
                </Grid>
                <Grid item xs={12} sm={1}>
                  <Typography align="center" fontWeight={600}>
                    OR
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" mb={1} fontWeight={600}>
                    Add boxes manually
                  </Typography>
                  <Typography variant="body1" mb={4}>
                    Enter one or more cryobox barcodes to add specific boxes to this shipment.
                  </Typography>
                  <form onSubmit={formik.handleSubmit}>
                    <Box display="flex" alignItems="flex-start" gap={1}>
                      <Box flex={1}>
                        <FormInput
                          label={t('forms.boxBarcode')}
                          type="text"
                          name="boxBarcode"
                          data-testid="boxBarcode"
                          error={formik.errors.boxBarcode}
                          touched={formik.touched.boxBarcode}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.boxBarcode}
                          margin="none"
                          startAdornment={<RiBarcodeLine fontSize={25} />}
                          endAdornment={
                            formik.values.boxBarcode && (
                              <IconButton
                                aria-label="clear"
                                size="small"
                                onClick={() => {
                                  formik.setFieldValue('boxBarcode', '');
                                }}
                              >
                                <FaUndo fontSize={20} color={theme.palette.error.dark} />
                              </IconButton>
                            )
                          }
                        />
                      </Box>

                      <Button
                        variant="contained"
                        onClick={() => handleScan(formik.values.boxBarcode)}
                        disabled={!formik.values.boxBarcode}
                        sx={{ height: 56, ml: '-5px' }}
                      >
                        Add
                      </Button>
                    </Box>
                  </form>
                </Grid>
              </Grid>
            </Paper>
          </>
        )}
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 2,
            border: '2px dashed',
            borderColor: 'divider',
            mt: 2,
          }}
        >
          <Grid container justifyContent="space-between" alignItems="flex-start" spacing={2} mb={3}>
            <Grid item xs={12} md={7}>
              <Typography variant="h5" fontWeight={700}>
                Staged boxes
              </Typography>

              <Stack direction="row" spacing={4} mt={1}>
                <Typography variant="body1">
                  Total Eligible Samples:{' '}
                  <Box component="span" sx={{ color: '#16A34A', fontWeight: 700 }} data-testid="staged-aliquot-count">
                    {eligibleSamplesCount ?? 0}
                  </Box>
                </Typography>

                <Typography variant="body1">
                  Total Boxes:{' '}
                  <Box component="span" sx={{ fontWeight: 700 }} data-testid="staged-boxes-count">
                    {staged?.cryoboxes?.length ?? 0}
                  </Box>
                </Typography>
              </Stack>
            </Grid>

            {ineligibleSamplesCount > 0 && (
              <Grid item>
                <Button
                  variant="contained"
                  color="error"
                  size="large"
                  sx={{
                    px: 4,
                    py: 1.5,
                    borderRadius: 1,
                    fontWeight: 700,
                  }}
                  data-testid="btnReviewSamplesToRemove"
                  onClick={() => setShowPickList(true)}
                >
                  REVIEW SAMPLES TO REMOVE ({ineligibleSamplesCount})
                </Button>
              </Grid>
            )}
            {staged && ineligibleSamplesCount === 0 && staged?.cryoboxes.length > 0 && (
              <Button
                data-testid="btnManifestShipment"
                variant="contained"
                color="success"
                size="large"
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 1,
                  fontWeight: 700,
                }}
                onClick={() => manifestShipment()}
              >
                MANIFEST SHIPMENT
              </Button>
            )}
          </Grid>
          <StatusMessage
            show={removeBoxHasError.hasError}
            severity="error"
            message={addCryoboxToStagingErrors.message}
            onClose={() => dispatch(removeCryoboxFromstagingReset())}
          />

          <StatusMessage
            show={removeBoxResponse?.cryoboxUuid !== undefined}
            severity="success"
            message={'Box has been removed successfully.'}
            onClose={() => dispatch(removeCryoboxFromstagingReset())}
          />
          {staged && staged?.cryoboxes?.length === 0 ? (
            <Box
              sx={{
                py: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Typography variant="h5" fontWeight={600}>
                Your shipment is empty
              </Typography>

              <Typography color="text.secondary">Click to start adding suggested boxes</Typography>
            </Box>
          ) : (
            <Box sx={{ width: '100%' }}>
              {renderShipmentAlert(ineligibleSamplesCount)}
              <TableContainer
                component={Box}
                sx={{
                  mt: 2,
                }}
              >
                <Table
                  sx={{
                    borderCollapse: 'separate',
                    borderSpacing: '0 12px',
                  }}
                >
                  <TableHead>
                    <TableRow
                      sx={{
                        backgroundColor: '#F5F5F5',
                        '& th': {
                          border: 0,
                          fontWeight: 700,
                          fontSize: 15,
                          color: '#374151',
                          py: 1.8,
                        },
                      }}
                    >
                      <TableCell width={70}></TableCell>
                      <TableCell>Box Serial No</TableCell>
                      <TableCell align="center">Samples</TableCell>
                      <TableCell align="center">Eligible</TableCell>
                      <TableCell align="center">Non-Eligible</TableCell>
                      {isAdmin(user) && <TableCell align="center">Action</TableCell>}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(staged?.cryoboxes || []).map((box, boxIndex) => {
                      const hasIssues = !box.eligible;

                      return (
                        <TableRow
                          key={box.cryoboxUuid}
                          data-testid={`stage-box-${boxIndex}`}
                          data-box-id={box.serialNo}
                          data-box-barcode={box.cryoboxBarcode}
                          sx={{
                            '& td': {
                              backgroundColor: hasIssues ? '#FFF5F5' : '#FFFFFF',
                              borderTop: `1px solid ${hasIssues ? '#FECACA' : '#E5E7EB'}`,
                              borderBottom: `1px solid ${hasIssues ? '#FECACA' : '#E5E7EB'}`,
                              py: 1.2,
                            },

                            '& td:first-of-type': {
                              borderLeft: `1px solid ${hasIssues ? '#FECACA' : '#E5E7EB'}`,
                              borderTopLeftRadius: 5,
                              borderBottomLeftRadius: 5,
                            },

                            '& td:last-of-type': {
                              borderRight: `1px solid ${hasIssues ? '#FECACA' : '#E5E7EB'}`,
                              borderTopRightRadius: 5,
                              borderBottomRightRadius: 5,
                            },
                          }}
                        >
                          <TableCell align="center">
                            {box.eligible ? (
                              <FaCheck color="#16A34A" size={20} />
                            ) : (
                              <MdWarningAmber color="#DC2626" size={22} />
                            )}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            <>
                              {box.serialNo}
                              {box.cryoboxBarcode !== '' && (
                                <>
                                  <br />
                                  <Box
                                    sx={{
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      gap: 0.5,
                                      py: 0.5,
                                      fontWeight: 'normal',
                                    }}
                                  >
                                    <RiBarcodeLine fontSize={15} />
                                    {box.cryoboxBarcode === null ? (
                                      '-------------'
                                    ) : (
                                      <span data-testid="boxBarcode">{box.cryoboxBarcode}</span>
                                    )}
                                  </Box>
                                </>
                              )}
                            </>
                          </TableCell>
                          <TableCell align="center" data-testid={`stage-box-${boxIndex}-total`}>
                            {box.eligibleCount + box.ineligibleCount}
                          </TableCell>
                          <TableCell
                            align="center"
                            color="success.main"
                            sx={{ color: '#16A34A', fontWeight: 700 }}
                            data-testid={`stage-box-${boxIndex}-eligible`}
                          >
                            {box.eligibleCount}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              color: box.ineligibleCount > 0 ? '#DC2626' : '#6B7280',
                              fontWeight: 700,
                            }}
                            data-testid={`stage-box-${boxIndex}-ineligible`}
                          >
                            {box.ineligibleCount}
                          </TableCell>
                          {isAdmin(user) && (
                            <TableCell align="center">
                              <Button
                                data-testid="btnRemoveBox"
                                variant="outlined"
                                onClick={() => deleteBox(box.cryoboxUuid)}
                                sx={{
                                  minWidth: 120,
                                  px: 3,

                                  border: '2px solid #FCA5A5',
                                  borderRadius: '5px',

                                  color: '#F87171',
                                  backgroundColor: '#fff',

                                  fontWeight: 700,
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',

                                  boxShadow: 'none',

                                  '&:hover': {
                                    backgroundColor: '#FFF5F5',
                                    border: '2px solid #F87171',
                                    color: '#EF4444',
                                    boxShadow: 'none',
                                  },

                                  '&:active': {
                                    boxShadow: 'none',
                                  },
                                }}
                              >
                                REMOVE
                              </Button>
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </Paper>

        <ConfirmationModal isOpen={showConfirm} onClose={() => setConfirm(false)} staged={staged} t={t} />

        <Loader data-testid="removing-message" isVisible={removeBoxIsBusy} label={`Removing in progress..`} />
        <Loader
          data-testid="adding-message"
          isVisible={addCryoboxToStagingBusy}
          label={`Adding Cryobox to staging...`}
        />
        <Loader
          data-testid="loading-message"
          isVisible={stagedMetaIsBusy || stagedIsBusy || resetStagedShipmentIsBusy || shipmentIsBusy}
          label={`Loading..`}
        />

        <ViewSuggestedBoxesModal
          eligibleSamplesCount={eligibleSamplesCount ?? 0}
          totalBoxes={staged?.cryoboxes?.length ?? 0}
          isOpen={showSearchEligibleBoxes}
          onClose={onViewSuggestedBoxesModalClose}
        />
        <PickListModal isOpen={showPickList} onClose={onPickListModalClose} />
      </>
    </InnerLayout>
  );
}

export default ManageShipmentScene;
